// @ts-ignore
import * as Locales from '../../public/locales/locales.json'

export enum LANGUAGES {
  FR = 'fr', EN = 'en'
}

export enum LOCALES {
  FR = 'fr-FR',
  EN = 'en-EN'
}

class I18n {
  readonly locales: any
  language: LANGUAGES
  constructor() {
    this.language = this.getLanguage()
    console.info('lang is ', this.language)
    this.locales = Locales[this.language]
  }

  getLanguage() {
    if (this.pageInEnglish()) { return LANGUAGES.EN }
    else { return LANGUAGES.FR }
  }

  pageInEnglish() {
    try {
      // @ts-ignore
      return Weglot.getCurrentLanguage() === 'en'
    } catch (error) {
      const url = window.location.href
      return url.match(/^https?:\/\/en\./) !== null
    }
  }

  t(entry: string) {
    const value = this.locales[entry]
    if (!value) {
      console.warn(`translation missing for ${value} in ${this.language}`)
    }
    return value
  }

  getLocale():LOCALES {
    const locale = this.getLanguage() === LANGUAGES.FR ? LOCALES.FR : LOCALES.EN
    return locale
  }

  parse(htmlContent:HTMLElement):string {
    return Array.from(htmlContent.querySelectorAll<HTMLElement>("[i18n]")).map((elem: HTMLElement) => {
      elem.innerText = this.t(elem.getAttribute("i18n")?.valueOf()!)
    }).join('')
  }
}

export const i18n = new I18n()